<template>
    <loading
        :show="show"
        :label="label"
    >
    </loading>
</template>

<script>
import loading from 'vue-full-loading'

export default {
    components: {
        loading,
    },
    props: {
        show: {
            default: false,
            type: Boolean,
        },
        label: {
            default: 'Please Wait...',
            type: String,
        },
    },
}
</script>